define('app/views/helper',['app/setup'], function(takhfifan) {

  takhfifan.Helper = {

    serializeToObject: function(view, selector, options) {
      var result = {};
      options = options || {};
      var except = options.except || [];

      inputElements = [
        'input:not(:submit,:checkbox)', 'input[type="checkbox"]:checked',
        'select', 'textarea'
      ];

      if (typeof selector == 'undefined') {
        selector = 'name';
      }

      view.$(inputElements.join(',')).each(function(i, el) {
        if (except.indexOf($(el).attr(selector)) == -1) {
          result[$(el).attr(selector)] = $(el).val();
        }
      });

      return result;
    },

    convertPersianNumbers: function (number) {
      return number.replace(/۰/g, '0')
                   .replace(/۱/g, '1')
                   .replace(/۲/g, '2')
                   .replace(/۳/g, '3')
                   .replace(/۴/g, '4')
                   .replace(/۵/g, '5')
                   .replace(/۶/g, '6')
                   .replace(/۷/g, '7')
                   .replace(/۸/g, '8')
                   .replace(/۹/g, '9');
    },

    formatPhone: function (phone) {
      return this.convertPersianNumbers(phone)
                 .replace(/[^\+\d]*/g, '');
    }

  }

});

